import React from "react";
import { Typography } from "@ucloud/ui-components";
import { LogoGoogle } from "@ucloud/ucloud-icons/dist/uc-social/svgr";
import { OAuthListWrapper } from "./style.jsx";
import localeService from "../../../service/localeService.js";
import { isChannelKeyEffect } from "../../../common/channel.js"

const { Text } = Typography;

const OAuthBtn = ({ type = "Login", bindChange }) => {
    // 和 UCloud 或 UCloud Global 域名相同的渠道入口不显示第三方注册
    if(isChannelKeyEffect()){
        return null;
    }

    return (
        <OAuthListWrapper>
            <div className='divider-line'>
                <Text color='light' size='t1' className='u-ml8 u-mr8'>
                    Or
                </Text>
            </div>
            {/* Google登录/注册 */}
            <div className='oauth-login-btn u-mb4' onClick={() => bindChange()}>
                <LogoGoogle className='btn-logo' />
                <span className='btn-text'>
                    {localeService.getTranslate(type === "Login" ? "LOGINBYGOOGLE" : "REGISTERBYGOOGLE")}
                </span>
            </div>
        </OAuthListWrapper>
    );
};

export default OAuthBtn;



// WEBPACK FOOTER //
// src/pc/components/ThirdPartyOAuth/OAuthBtn.jsx